import { render } from "./ImageSlider.vue?vue&type=template&id=72998100"
const script = {}

import exportComponent from "C:\\Users\\Mori\\Desktop\\aptopler-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__